import platform from 'components/Trackers/platform'

export const ScreenViewedEvent = {
  feature: 'MOC Registration Funnel',
  event_description: 'Screen Viewed',
  platform,
  object: 'Screen',
  action: 'Viewed',
  object_name: 'registrationMOCProgressStepTwo',
  screen: 'registrationMOCProgressStepTwo',
  screen_name: 'registrationMOCProgressStepTwo',
}

export const NextButtonTappedEvent = {
  feature: 'MOC Registration Funnel',
  event_description: 'MOC Progress Step Two Next button tapped',
  platform,
  object: 'Button',
  action: 'Tapped',
  object_name: 'mocRegistrationProgressTwoNext',
  screen: 'mocRegistrationFunnelProgressTwoNext',
  screen_name: 'mocRegistrationFunnelProgressTwoNext',
}
